export default {
  title: '2. Strong, Healthy Homes',
  visionTitle: 'VISION',
  visionSubHeader: 'New York homeowners and their tenants live in safe, healthy homes. Physical conditions set  families up for the best possible health outcomes.',
  visionBody: "Everyone wants to raise their family in a healthy home that's free of mold, lead, asthma triggers, or other safety defects. However, many of our homes are in a state of deterioration due to our aging housing stock and decades of disinvestment. Today, many New York City  families struggle to afford repairs and maintenance that would combat potential health hazards. Because of the legacy of redlining, environmental racism, and predatory lending, people of color are more likely to live in unhealthy homes. These communities should be a top priority for channeling resources to support healthy, sustainable homeownership.",
  goalTitle: 'GOALS',
  datapoint: 'Nearly a <span class="highlight">third of owner-occupied homes in New York City</span>&mdash;323,000 out of 1,100,000&mdash;have at least one maintenance defect, defined as water leaks, cracks and holes, inadequate heating, mice or rats, toilet breakdowns or peeling paint.',
  goals: [
    {
      id: 'funding',
      content: 'Increase <strong>funding</strong> for home repair programs and develop affordable home repair lending programs.'
    },
    {
      id: 'repair',
      content: 'Design  specific interventions for homeowners facing health risks due to home maintenance issues. Target resources to communities of color that have experienced redlining, poor access to credit, and other forms of disinvestment.'
    },
    {
      id: 'medical',
      content: 'Engage <strong>medical institutions</strong> in the development of strategies to reduce hospitalizations by improving the physical conditions of homes, and ensure cross-referrals to home repair and other wellness resources.'
    },
    {
      id: 'home repair',
      content: 'Create an interactive home repair guide to educate homeowners and to help them <strong>identify and test</strong> their homes for <strong>environmental hazards</strong>, including resources to obtain affordable financing options to address these risks.'
    },
    {
      id: 'tenant safety',
      content: 'Promote <strong>tenant safety</strong> in 1-4 family homes by funding programs to address health and safety violations, legalize safe basement apartment units, and make other safety-promoting repairs.'
    }
  ]
};
